import { Button, Modal, Spinner, TextField, Typography } from '@scale/scaleui';
import { useState } from 'react';
import { useMutation } from '@tanstack/react-query-v4';
import apiFetch from '@scale/frontend-lib/api-fetch';

interface DuplicateFlowModalProps {
  isOpen: boolean;
  onClose: () => void;
  flowName: string;
  flowId: string;
}

export const DuplicateFlowModal: React.FC<DuplicateFlowModalProps> = ({
  isOpen,
  onClose,
  flowName,
  flowId,
}) => {
  const [name, setName] = useState<string | undefined>(undefined);

  const { mutate, data, error, isLoading, isError } = useMutation<
    { id: string },
    { response?: { message: string }; message: string },
    { flowId: string; newFlowName: string | undefined },
    any
  >(async ({ flowId, newFlowName }: { flowId: string; newFlowName: string | undefined }) => {
    try {
      return await apiFetch(null, `corp-api/onboarding-control-panel/flow/duplicate`, {
        method: 'POST',
        body: {
          flowId,
          newFlowName,
        },
      });
    } catch (e) {
      if (e.response.status === 400) {
        throw e.response;
      }
      throw e;
    }
  });
  const handleSubmit = () => {
    mutate({ flowId, newFlowName: name });
  };

  return (
    <Modal open={isOpen} onClose={onClose} title={`Duplicate ${flowName}`}>
      <Typography.Paragraph3>
        Signup flows will not be duplicated to the new flow.
      </Typography.Paragraph3>
      <TextField
        className="my-4"
        id="flow-name"
        label={`Optional Flow Name: Defaults to ${flowName} (copy)`}
        placeholder={`${flowName} (copy)`}
        type="text"
        value={name}
        onChange={e => setName(e.target.value)}
      />
      <div className="flex justify-end">
        {isLoading && <Spinner size="sm" className="mr-4" />}
        <Button onClick={handleSubmit}>Submit</Button>
      </div>
      {isError && error && (
        <p style={{ color: 'red' }} className="flex flex-col gap-y-2 my-2 text-xs">
          {`Failed to duplicate flow: ${error.response?.message ?? error.message}`}
        </p>
      )}
      {data && (
        <div className="flex flex-col gap-y-2 my-2">
          <Typography.Paragraph3>{`New flow id ${data.id}`}</Typography.Paragraph3>
        </div>
      )}
    </Modal>
  );
};
